module.exports = __webpack_public_path__ + "static/media/pro.7f02549a.png";